import { useEffect, useState, useMemo } from 'react'
import i18n from './index'

const useI18n = () => {
  const [language, setLanguage] = useState(i18n.language || i18n.options.lng || 'tr')

  useEffect(() => {
    const handleChange = (lng) => setLanguage(lng)
    i18n.on('languageChanged', handleChange)
    return () => {
      i18n.off('languageChanged', handleChange)
    }
  }, [])

  const t = useMemo(() => i18n.t.bind(i18n), [language])

  return {
    i18n,
    t,
    language,
    changeLanguage: i18n.changeLanguage.bind(i18n)
  }
}

export default useI18n

